import React from 'react';
import { FullTable } from 'components';
import { ReportsBody, ReportsHead, ReportsNotYet } from './constants';
import { sortListByKey, useModal } from 'utils';
import { GenerateReport, clinicalReportEnums } from './core';

export const ClinicalReports = ({}) => {
    const { open } = useModal();

    const openGenerate = (item) => {
        open(<GenerateReport info={item?.generateInfo} />);
    };

    return (
        <div>
            <FullTable
                head={ReportsHead}
                body={ReportsBody(openGenerate)}
                list={sortListByKey(clinicalReportEnums, 'name')}
                notYet={ReportsNotYet('Notes')}
                activeRowId={''}
                margin={'0'}
            />
        </div>
    );
};
